import { render, staticRenderFns } from "./HomePromoter.vue?vue&type=template&id=17881b40&"
import script from "./HomePromoter.vue?vue&type=script&lang=js&"
export * from "./HomePromoter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports